// extracted by mini-css-extract-plugin
export default {"nameColumn":"SalesMetrosTable_nameColumn__9kluq","iconColumn":"SalesMetrosTable_iconColumn__QqglL","name":"SalesMetrosTable_name__4q2nm"};